export default __webpack_public_path__ + "static/media/shopMens.1b9242a9.jpg";